module.exports = __webpack_public_path__ + "e622124f2acbdbf7670d38aa44ce8d70.pdf";